import Transform from '@ember-data/serializer/transform';

export default class ObjectTransform extends Transform {
	deserialize(serialized: object | null | undefined): object | null {
		return serialized && Object.keys(serialized).length ? serialized : null;
	}

	serialize(deserialized: object | null | undefined): object | null {
		return deserialized && Object.keys(deserialized).length ? deserialized : null;
	}
}

declare module '@ember-data/serializer/transform' {
	interface TransformRegistry {
		'object-or-null': object | null;
	}
}
